export default [
    {
        key: 'directdebit',
        label: 'Direct Debit',
        components: [
            {
                type: 'checkbox',
                label: 'Enable Direct Debit',
                key: 'directdebit',
                defaultValue: true,
                input: true,
                weight: 70,
                tooltip: 'Check this if you want to allow for a Direct Debit Mandate .',
            },
            {
                type: 'checkbox',
                label: 'Enable for single payments',
                key: 'directdebit_once',
                input: true,
                weight: 20,
                tooltip: 'Check this if you want to allow for Direct Debit mandates when frequency is set to "Once".',
                defaultValue: true,
                customConditional: function customConditional(ctx) {
                    return ctx.data.directdebit;
                },
            },
            {
                type: 'checkbox',
                label: 'Enable for monthly payments',
                key: 'directdebit_monthly',
                input: true,
                weight: 20,
                tooltip: 'Check this if you want to allow for Direct Debit mandates when frequency is set to "Monthly".',
                defaultValue: true,
                customConditional: function customConditional(ctx) {
                    return ctx.data.directdebit;
                },
            },
            {
                type: 'checkbox',
                label: 'Enable for yearly payments',
                key: 'directdebit_yearly',
                input: true,
                weight: 20,
                tooltip: 'Check this if you want to allow for Direct Debit mandates when frequency is set to "Yearly".',
                defaultValue: true,
                customConditional: function customConditional(ctx) {
                    return ctx.data.directdebit;
                },
            },
            {
                type: 'textfield',
                label: 'Direct Debit label',
                key: 'directdebit_label',
                tooltip: 'Set the label for the Direct Debit option',
                input: true,
                allowCalculateOverride: 0,
                defaultValue: 'Direct Debit',
                weight: 80,
                customConditional: function customConditional(ctx) {
                    return ctx.data.directdebit;
                },
            },
            {
                type: 'textfield',
                label: 'IBAN label',
                key: 'iban_label',
                tooltip: 'Set the label for the IBAN field',
                input: true,
                allowCalculateOverride: 0,
                defaultValue: '',
                weight: 90,
                customConditional: function customConditional(ctx) {
                    return ctx.data.directdebit;
                },
            },
            {
                type: 'textfield',
                label: 'IBAN suffix',
                key: 'iban_suffix',
                tooltip: 'Set the suffix for the IBAN field',
                input: true,
                allowCalculateOverride: 0,
                defaultValue: '',
                weight: 90,
                customConditional: function customConditional(ctx) {
                    return ctx.data.directdebit;
                },
            },
            {
                type: 'textfield',
                label: 'BIC label',
                key: 'bic_label',
                tooltip: 'Set the label for the BIC field',
                input: true,
                allowCalculateOverride: 0,
                defaultValue: '',
                weight: 100,
                customConditional: function customConditional(ctx) {
                    return ctx.data.directdebit;
                },
            },
            {
                type: 'textfield',
                label: 'BIC suffix',
                key: 'bic_suffix',
                tooltip: 'Set the suffix for the BIC field',
                input: true,
                allowCalculateOverride: 0,
                defaultValue: '',
                weight: 90,
                customConditional: function customConditional(ctx) {
                    return ctx.data.directdebit;
                },
            },
            {
                weight: 110,
                type: 'textarea',
                input: true,
                key: 'directdebit_description',
                label: 'Description',
                placeholder: 'Description for this field.',
                tooltip: 'The description is text that will appear below the input field.',
                editor: 'ace',
                as: 'html',
                wysiwyg: {
                    minLines: 3,
                    isUseWorkerDisabled: true,
                },
                customConditional: function customConditional(ctx) {
                    return ctx.data.directdebit;
                },
            },
        ],
    },
];
